import Vue from 'vue'
import Notifications from 'vue-notification'
import Notify from 'core/components/Notify'

Vue.use(Notifications)
Vue.component('notify', Notify)

export default Vue
